import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  FaUser, FaLock, FaEnvelope, FaUsers,
  FaCamera, FaCheck, FaEye, FaEyeSlash, FaPlus, FaTrash,
  FaSave, FaSignOutAlt,
  FaKey, FaToggleOn, FaToggleOff, FaShieldAlt, FaSpinner, FaTimes
} from 'react-icons/fa';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import { API_URL as API, resolveAvatarUrl } from '../config/api';

const ROLE_COLOR = {
  super_admin: { color: '#198754', bg: 'rgba(25,135,84,0.1)',  label: 'Super Admin' },
  admin:       { color: '#0d6efd', bg: 'rgba(13,110,253,0.1)', label: 'Admin'       },
};

const SB_OPEN    = 252;
const SB_CLOSED  =  74;
const SB_GAP     =  12;
const NB_HEIGHT  =  68;
const NB_TOP     =  12;

const resolveAvatar = (path) => resolveAvatarUrl(path);

// Cle localStorage dediee a l'URL resolue de l'avatar
const AVATAR_LS_KEY = 'admin_avatar_url';

const useToast = () => {
  const [toasts, setToasts] = useState([]);
  const add = useCallback((msg, type = 'success') => {
    const id = Date.now();
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3000);
  }, []);
  return { toasts, add };
};

const ToastBar = ({ toasts }) => (
  <div style={{ position:'fixed', bottom:28, right:28, zIndex:9999, display:'flex', flexDirection:'column', gap:8 }}>
    {toasts.map(t => (
      <div key={t.id} style={{
        display:'flex', alignItems:'center', gap:10, padding:'13px 20px',
        borderRadius:12, minWidth:260, fontFamily:"'Plus Jakarta Sans',sans-serif",
        background: t.type==='success' ? '#198754' : t.type==='error' ? '#dc3545' : '#fd7e14',
        color:'#fff', boxShadow:'0 8px 28px rgba(0,0,0,0.25)', animation:'pm-slide 0.3s ease',
      }}>
        <span style={{ fontSize:14 }}>{t.type==='success' ? '✓' : t.type==='error' ? '✕' : '!'}</span>
        <p style={{ flex:1, fontSize:13, fontWeight:600, margin:0 }}>{t.msg}</p>
      </div>
    ))}
  </div>
);

const InviteModal = ({ onClose, onInvite, c, isDark }) => {
  const [form,    setForm]    = useState({ nom_complet:'', email:'', role:'admin' });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!form.nom_complet || !form.email) return;
    setLoading(true);
    try { await onInvite(form); onClose(); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(9,12,22,0.8)', backdropFilter:'blur(6px)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:2000, padding:20 }} onClick={onClose}>
      <div style={{ background:c.card, border:`1px solid ${c.cardB}`, borderRadius:18, width:'100%', maxWidth:440, boxShadow:'0 24px 60px rgba(0,0,0,0.25)', animation:'pm-pop .26s ease', overflow:'hidden' }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 22px', borderBottom:`1px solid ${c.divider}`, background:isDark?'rgba(255,255,255,0.02)':'#fafbfc' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:36, height:36, borderRadius:9, background:'rgba(25,135,84,0.1)', color:'#198754', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15 }}><FaPlus /></div>
            <span style={{ fontSize:16, fontWeight:700, color:c.title }}>Inviter un administrateur</span>
          </div>
          <button onClick={onClose}
            style={{ width:32, height:32, borderRadius:8, border:`1.5px solid ${c.cardB}`, background:'transparent', color:c.textDim, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, transition:'all .18s' }}
            onMouseEnter={e=>{e.currentTarget.style.background='#dc3545';e.currentTarget.style.color='#fff';}}
            onMouseLeave={e=>{e.currentTarget.style.background='transparent';e.currentTarget.style.color=c.textDim;}}>
            <FaTimes />
          </button>
        </div>
        <div style={{ padding:22 }}>
          <p style={{ fontSize:13, color:c.textDim, marginBottom:18, lineHeight:1.7 }}>
            Un email contenant les identifiants de connexion sera automatiquement envoyé à l'adresse saisie.
          </p>
          {[
            { label:'Nom complet', field:'nom_complet', type:'text',  ph:'Jean Dupont'     },
            { label:'Email',       field:'email',       type:'email', ph:'admin@cinef.org' },
          ].map(f => (
            <div key={f.field} style={{ marginBottom:14 }}>
              <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'.6px', display:'block', marginBottom:6 }}>{f.label}</label>
              <input type={f.type} value={form[f.field]} placeholder={f.ph}
                onChange={e=>setForm(p=>({...p,[f.field]:e.target.value}))}
                style={{ width:'100%', padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
                onFocus={e=>e.target.style.borderColor='#198754'}
                onBlur={e=>e.target.style.borderColor=c.inputB}
              />
            </div>
          ))}
          <div style={{ marginBottom:22 }}>
            <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'.6px', display:'block', marginBottom:6 }}>Rôle</label>
            <select value={form.role} onChange={e=>setForm(p=>({...p,role:e.target.value}))}
              style={{ width:'100%', padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none' }}>
              <option value="admin">Admin</option>
              <option value="super_admin">Super Admin</option>
            </select>
          </div>
          <div style={{ display:'flex', gap:9, justifyContent:'flex-end' }}>
            <button onClick={onClose} style={{ padding:'10px 18px', background:'transparent', border:`1.5px solid ${c.cardB}`, borderRadius:10, fontSize:13, fontWeight:600, color:c.text, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Annuler</button>
            <button onClick={submit} disabled={!form.nom_complet||!form.email||loading}
              style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 20px', background:'#198754', color:'#fff', border:'none', borderRadius:10, fontSize:13, fontWeight:700, cursor:'pointer', opacity:(!form.nom_complet||!form.email)?0.45:1, fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
              {loading ? <><FaSpinner style={{animation:'pm-spin .8s linear infinite'}}/> Envoi…</> : <><FaPlus />Inviter</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Settings = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const { toasts, add: toast } = useToast();
  const fileRef = useRef();

  const token        = localStorage.getItem('admin_token');
  const headers      = { Authorization: `Bearer ${token}` };
  const currentUser  = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const isSuperAdmin = currentUser.role === 'super_admin';

  const ALL_SECTIONS = [
    { id:'profil',       icon:<FaUser />,     label:'Profil'                },
    { id:'securite',     icon:<FaLock />,     label:'Sécurité'              },
    { id:'emails',       icon:<FaEnvelope />, label:'Emails système',  superOnly:true },
    { id:'utilisateurs', icon:<FaUsers />,    label:'Utilisateurs & Rôles', superOnly:true },
  ];
  const SECTIONS = ALL_SECTIONS.filter(s => !s.superOnly || isSuperAdmin);
  const [activeSection, setActiveSection] = useState(SECTIONS[0]?.id || 'profil');

  const [loadingProfil,   setLoadingProfil]   = useState(false);
  const [loadingPwd,      setLoadingPwd]      = useState(false);
  const [loadingEmail,    setLoadingEmail]    = useState(false);
  const [showInvite,      setShowInvite]      = useState(false);
  const [avatarUploading, setAvatarUploading] = useState(false);

  // FIX 1 : avatarUrl dans un state dedie, initialise depuis localStorage
  // Cela permet a l'avatar de persister entre les changements de section
  const [avatarUrl, setAvatarUrl] = useState(() => {
    const cached = localStorage.getItem(AVATAR_LS_KEY);
    if (cached) return cached;
    const u = JSON.parse(localStorage.getItem('admin_user') || '{}');
    return resolveAvatar(u.avatar);
  });

  // FIX 2 : profil sans avatar (avatar gere separement)
  const [profil, setProfil] = useState({
    civilite:'M.', prenom:'', nom:'', email:'',
    telephone:'', poste:'', bio:'',
  });

  const [securite, setSecurite] = useState({
    currentPwd:'', newPwd:'', confirmPwd:'',
    show:{ current:false, new:false, confirm:false },
    twoFA:false, sessionTimeout:'60',
  });

  const [emails, setEmails] = useState({
    sender_name:'CINEF Formation', sender_email:'', smtp_host:'smtp.gmail.com',
    smtp_port:'587', smtp_user:'', smtp_pass:'',
    footer:'', signature_active:true,
  });

  const [users, setUsers] = useState([]);

  const c = isDark ? {
    bg:'#090c16', card:'rgba(255,255,255,0.04)', cardB:'rgba(255,255,255,0.08)',
    text:'#c8d4e0', textDim:'#5a6b82', title:'#eef2f7',
    surface:'rgba(255,255,255,0.05)', input:'rgba(255,255,255,0.06)', inputB:'rgba(255,255,255,0.12)',
    inputT:'#eef2f7', shadow:'0 4px 24px rgba(0,0,0,0.4)',
    navBg:'rgba(255,255,255,0.03)', navOn:'rgba(25,135,84,0.15)', divider:'rgba(255,255,255,0.07)',
  } : {
    bg:'#f0f3f8', card:'#ffffff', cardB:'rgba(0,0,0,0.07)',
    text:'#4d6070', textDim:'#8fa3b5', title:'#1a2535',
    surface:'rgba(0,0,0,0.04)', input:'#f7f9fb', inputB:'rgba(0,0,0,0.1)',
    inputT:'#1a2535', shadow:'0 2px 12px rgba(0,0,0,0.06)',
    navBg:'#ffffff', navOn:'rgba(25,135,84,0.08)', divider:'rgba(0,0,0,0.07)',
  };

  const mainML = `${SB_GAP + (sidebarOpen ? SB_OPEN : SB_CLOSED) + 12}px`;
  const mainPT = `${NB_TOP + NB_HEIGHT + 12}px`;
  const Spin   = () => <FaSpinner style={{ animation:'pm-spin .8s linear infinite', fontSize:13 }} />;

  // FIX 3 : Fetch profil — avatar et champs texte geres separement
  useEffect(() => {
    axios.get(`${API}/admin/settings/profil`, { headers })
      .then(({ data }) => {
        // Log pour debug
        console.log('📥 Chargement profil depuis serveur:', data);
        
        // Le backend renvoie nom_complet, pas prenom/nom séparés
        // Parser nom_complet pour extraire prenom et nom
        const nomComplet = data.nom_complet || '';
        const parts = nomComplet.trim().split(' ');
        const prenom = parts.slice(0, -1).join(' ') || ''; // Tout sauf le dernier mot
        const nom = parts[parts.length - 1] || '';         // Dernier mot
        
        // Champs texte
        setProfil({
          civilite:  data.civilite  || 'M.',
          prenom:    prenom,
          nom:       nom,
          email:     data.email     || '',
          telephone: data.telephone || '',
          poste:     data.poste     || '',
          bio:       data.bio       || '',
        });

        // Avatar : ne mettre a jour que si pas deja en cache local
        if (data.avatar) {
          const resolved = resolveAvatar(data.avatar);
          // Toujours mettre a jour le cache avec la valeur du serveur au chargement
          setAvatarUrl(resolved);
          localStorage.setItem(AVATAR_LS_KEY, resolved);
          // Sync admin_user
          const u = JSON.parse(localStorage.getItem('admin_user') || '{}');
          localStorage.setItem('admin_user', JSON.stringify({ ...u, avatar: data.avatar }));
        }
      })
      .catch((err) => {
        console.error('❌ Erreur chargement profil:', err.response?.data || err);
      });
  }, []); // Executer une seule fois au montage

  useEffect(() => {
    if (activeSection === 'emails' && isSuperAdmin) {
      axios.get(`${API}/admin/settings/emails`, { headers })
        .then(({ data }) => setEmails(p => ({ ...p, ...data })))
        .catch(() => {});
    }
    if (activeSection === 'utilisateurs' && isSuperAdmin) {
      fetchUsers();
    }
  }, [activeSection]);

  const fetchUsers = () => {
    axios.get(`${API}/admin/settings/users`, { headers })
      .then(({ data }) => setUsers(data))
      .catch(() => {});
  };

  // FIX 4 : saveProfil met a jour le state local avec la reponse serveur
  const saveProfil = async () => {
    setLoadingProfil(true);
    try {
      // Log pour debug
      console.log('📤 Envoi des données profil:', profil);
      
      // Le backend attend prenom et nom séparés (validation Laravel)
      // Mais sauvegarde dans nom_complet et ne les retourne pas
      const { data } = await axios.put(`${API}/admin/settings/profil`, {
        civilite:  profil.civilite,
        prenom:    profil.prenom,    // Requis par la validation Laravel
        nom:       profil.nom,        // Requis par la validation Laravel
        email:     profil.email,
        telephone: profil.telephone,
        poste:     profil.poste,
        bio:       profil.bio,
      }, { headers });

      // Log pour debug
      console.log('📥 Réponse du serveur:', data);

      // Le state reste tel quel (le backend a accepté les données)
      // Pas besoin de recharger car on garde déjà les bonnes valeurs

      // Sync localStorage avec nom_complet
      const u = JSON.parse(localStorage.getItem('admin_user') || '{}');
      localStorage.setItem('admin_user', JSON.stringify({
        ...u,
        nom_complet: `${profil.prenom} ${profil.nom}`.trim(),
        email: profil.email,
      }));

      toast('Profil mis à jour avec succès');
    } catch (e) {
      console.error('❌ Erreur sauvegarde profil:', e.response?.data || e);
      toast(e.response?.data?.message || 'Erreur lors de la sauvegarde', 'error');
    } finally {
      setLoadingProfil(false);
    }
  };

  // FIX 5 : saveAvatar persiste l'URL resolue dans localStorage (cle dediee)
  const saveAvatar = async (file) => {
    const blobUrl = URL.createObjectURL(file);
    setAvatarUrl(blobUrl); // Previsualisation immediate
    setAvatarUploading(true);

    const form = new FormData();
    form.append('avatar', file);

    try {
      const { data } = await axios.post(`${API}/admin/settings/profil/avatar`, form, {
        headers: { ...headers, 'Content-Type': 'multipart/form-data' },
      });

      const realUrl = resolveAvatar(data.avatar);

      // Persister l'URL resolue — survie entre navigations de sections
      setAvatarUrl(realUrl);
      localStorage.setItem(AVATAR_LS_KEY, realUrl);

      // Sync admin_user
      const u = JSON.parse(localStorage.getItem('admin_user') || '{}');
      localStorage.setItem('admin_user', JSON.stringify({ ...u, avatar: data.avatar }));

      // Notifier la Navbar avec l'URL deja resolue
      window.dispatchEvent(new CustomEvent('avatar-updated', { detail: realUrl }));

      toast('Photo de profil mise à jour');
    } catch {
      // Restaurer l'ancien avatar depuis le cache
      const cached = localStorage.getItem(AVATAR_LS_KEY);
      setAvatarUrl(cached || null);
      toast("Erreur lors de l'upload de la photo", 'error');
    } finally {
      setAvatarUploading(false);
    }
  };

  // FIX 6 : removeAvatar nettoie aussi localStorage
  const removeAvatar = () => {
    setAvatarUrl(null);
    localStorage.removeItem(AVATAR_LS_KEY);
    const u = JSON.parse(localStorage.getItem('admin_user') || '{}');
    localStorage.setItem('admin_user', JSON.stringify({ ...u, avatar: null }));
    window.dispatchEvent(new CustomEvent('avatar-updated', { detail: null }));
  };

  const savePassword = async () => {
    if (securite.newPwd !== securite.confirmPwd) {
      toast('Les mots de passe ne correspondent pas', 'error'); return;
    }
    if (securite.newPwd.length < 8) {
      toast('Minimum 8 caractères requis', 'error'); return;
    }
    setLoadingPwd(true);
    try {
      await axios.put(`${API}/admin/settings/password`, {
        current_password:          securite.currentPwd,
        new_password:              securite.newPwd,
        new_password_confirmation: securite.confirmPwd,
      }, { headers });
      setSecurite(p => ({ ...p, currentPwd:'', newPwd:'', confirmPwd:'' }));
      toast('Mot de passe mis à jour');
    } catch (e) {
      toast(e.response?.data?.message || 'Mot de passe actuel incorrect', 'error');
    } finally {
      setLoadingPwd(false);
    }
  };

  const revokeOtherSessions = async () => {
    try {
      await axios.post(`${API}/admin/settings/revoke-sessions`, {}, { headers });
      toast('Autres sessions révoquées avec succès');
    } catch {
      toast('Erreur', 'error');
    }
  };

  const saveEmails = async () => {
    setLoadingEmail(true);
    try {
      await axios.put(`${API}/admin/settings/emails`, emails, { headers });
      toast('Configuration email enregistrée');
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur', 'error');
    } finally {
      setLoadingEmail(false);
    }
  };

  const testSmtp = async () => {
    setLoadingEmail(true);
    try {
      const { data } = await axios.post(`${API}/admin/settings/emails/test-smtp`, {}, { headers });
      toast(data.message);
    } catch (e) {
      toast(e.response?.data?.message || 'Échec SMTP', 'error');
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleInvite = async (form) => {
    try {
      await axios.post(`${API}/admin/settings/users/invite`, form, { headers });
      toast('Invitation envoyée avec succès');
      fetchUsers();
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur invitation', 'error');
    }
  };

  const changeUserRole = async (id, role) => {
    try {
      await axios.patch(`${API}/admin/settings/users/${id}/role`, { role }, { headers });
      setUsers(p => p.map(u => u.id === id ? { ...u, role } : u));
      toast('Rôle mis à jour');
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur', 'error');
    }
  };

  const toggleUserActif = async (id) => {
    if (id === currentUser.id) return;
    try {
      const { data } = await axios.patch(`${API}/admin/settings/users/${id}/toggle-actif`, {}, { headers });
      setUsers(p => p.map(u => u.id === id ? { ...u, actif: data.actif } : u));
      toast('Statut mis à jour');
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur', 'error');
    }
  };

  const deleteUser = async (id) => {
    if (id === currentUser.id) return;
    if (!window.confirm('Supprimer cet utilisateur définitivement ?')) return;
    try {
      await axios.delete(`${API}/admin/settings/users/${id}`, { headers });
      setUsers(p => p.filter(u => u.id !== id));
      toast('Utilisateur supprimé');
    } catch (e) {
      toast(e.response?.data?.message || 'Erreur', 'error');
    }
  };

  const Input = ({ label, value, onChange, type='text', placeholder='', half=false }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:6, gridColumn: half ? 'span 1' : 'span 2' }}>
      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>{label}</label>
      <input type={type} value={value} onChange={onChange} placeholder={placeholder}
        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', transition:'border-color 0.2s', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
        onFocus={e=>e.target.style.borderColor='#198754'}
        onBlur={e=>e.target.style.borderColor=c.inputB}
      />
    </div>
  );

  const Toggle = ({ on, onToggle, label, desc }) => (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 16px', background:c.surface, borderRadius:11, border:`1px solid ${c.cardB}` }}>
      <div>
        <div style={{ fontSize:14, fontWeight:600, color:c.title, marginBottom:2 }}>{label}</div>
        {desc && <div style={{ fontSize:12, color:c.textDim }}>{desc}</div>}
      </div>
      <button onClick={onToggle} style={{ background:'none', border:'none', cursor:'pointer', fontSize:26, color: on ? '#198754' : c.textDim, transition:'color 0.2s', flexShrink:0 }}>
        {on ? <FaToggleOn /> : <FaToggleOff />}
      </button>
    </div>
  );

  const SectionHeader = ({ icon, title, desc }) => (
    <div style={{ marginBottom:24 }}>
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:6 }}>
        <div style={{ width:38, height:38, borderRadius:10, background:'rgba(25,135,84,0.1)', color:'#198754', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16 }}>{icon}</div>
        <h2 style={{ fontSize:18, fontWeight:700, color:c.title, margin:0 }}>{title}</h2>
      </div>
      <p style={{ fontSize:13, color:c.textDim, margin:'0 0 0 50px' }}>{desc}</p>
    </div>
  );

  const Block = ({ title, children, style={} }) => (
    <div style={{ background:c.card, border:`1px solid ${c.cardB}`, borderRadius:14, padding:'22px 24px', marginBottom:16, boxShadow:c.shadow, ...style }}>
      {title && <div style={{ fontSize:12, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.7px', marginBottom:18, paddingBottom:12, borderBottom:`1px solid ${c.divider}` }}>{title}</div>}
      {children}
    </div>
  );

  // FIX 7 : AvatarDisplay utilise le state avatarUrl dedie (pas profil.avatar)
  const AvatarDisplay = ({ size = 72, radius = '16px', fontSize = 22 }) => (
    <div
      style={{ width:size, height:size, borderRadius:radius, overflow:'hidden', flexShrink:0, position:'relative', background:'linear-gradient(135deg,#fd7e14,#dc3545)', cursor:'pointer' }}
      onClick={() => fileRef.current?.click()}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="avatar"
          style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}
          onError={() => {
            setAvatarUrl(null);
            localStorage.removeItem(AVATAR_LS_KEY);
          }}
        />
      ) : (
        <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize, fontWeight:700 }}>
          {(profil.prenom?.[0] || currentUser.nom_complet?.[0] || '?')}
          {(profil.nom?.[0] || '')}
        </div>
      )}
      <div className="pm-avatar-overlay">
        {avatarUploading ? <FaSpinner style={{ animation:'pm-spin .8s linear infinite' }} /> : <FaCamera />}
      </div>
    </div>
  );

  return (
    <div style={{ background:c.bg, minHeight:'100vh', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;font-family:'Plus Jakarta Sans',sans-serif}
        @keyframes pm-slide{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
        @keyframes pm-pop{from{opacity:0;transform:scale(0.93) translateY(12px)}to{opacity:1;transform:none}}
        @keyframes pm-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        .pm-main{transition:margin-left .28s cubic-bezier(.4,0,.2,1)}
        .pm-layout{display:flex;gap:20px;padding:20px 24px 40px}
        .pm-nav{width:220px;flex-shrink:0}
        .pm-nav-card{border-radius:14px;border:1px solid;overflow:hidden;position:sticky;top:20px}
        .pm-nav-item{display:flex;align-items:center;gap:11px;padding:12px 16px;font-size:14px;font-weight:500;cursor:pointer;transition:all .18s;border:none;width:100%;text-align:left}
        .pm-nav-item:not(:last-child){border-bottom:1px solid}
        .pm-content{flex:1;min-width:0}
        .pm-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
        .pm-grid-1{display:grid;grid-template-columns:1fr;gap:14px}
        .pm-avatar-wrap{display:flex;align-items:center;gap:20px;padding:20px;background:rgba(25,135,84,.05);border-radius:12px;border:1px solid rgba(25,135,84,.12);margin-bottom:20px}
        .pm-avatar-overlay{position:absolute;inset:0;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;font-size:18px;color:#fff}
        div:hover > .pm-avatar-overlay{opacity:1}
        .pm-btn-primary{display:inline-flex;align-items:center;gap:8px;padding:11px 22px;background:#198754;color:#fff;border:none;border-radius:11px;font-size:14px;font-weight:600;cursor:pointer;transition:all .2s;font-family:'Plus Jakarta Sans',sans-serif}
        .pm-btn-primary:hover:not(:disabled){background:#157347;transform:translateY(-1px)}
        .pm-btn-primary:disabled{opacity:.5;cursor:not-allowed;transform:none}
        .pm-btn-ghost{display:inline-flex;align-items:center;gap:8px;padding:11px 22px;background:transparent;border:1.5px solid;border-radius:11px;font-size:14px;font-weight:600;cursor:pointer;transition:all .2s;font-family:'Plus Jakarta Sans',sans-serif}
        .pm-pwd-wrap{position:relative}
        .pm-pwd-eye{position:absolute;right:14px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;font-size:14px;transition:color .2s;padding:0}
        .pm-utbl{width:100%;border-collapse:collapse}
        .pm-utbl th{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;padding:10px 14px;text-align:left}
        .pm-utbl td{padding:13px 14px;border-bottom:1px solid;vertical-align:middle}
        .pm-utbl tr:last-child td{border-bottom:none}
        .pm-uav{width:34px;height:34px;border-radius:9px;background:#1a2535;color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;position:relative}
        .pm-role-select{border:1.5px solid;border-radius:8px;padding:5px 10px;font-size:13px;font-weight:600;cursor:pointer;outline:none;font-family:'Plus Jakarta Sans',sans-serif}
        .pm-online-dot{width:9px;height:9px;border-radius:50%;position:absolute;bottom:2px;right:2px;border:1.5px solid}
        @media(max-width:1024px){.pm-main{margin-left:0!important}.pm-layout{flex-direction:column}.pm-nav{width:100%}.pm-nav-card{position:static;display:flex;flex-wrap:wrap}.pm-nav-item{flex:1;min-width:120px;justify-content:center;border-bottom:none!important;border-right:1px solid}}
        @media(max-width:768px){.pm-layout{padding:14px 14px 32px}.pm-grid{grid-template-columns:1fr}}
      `}</style>

      <ToastBar toasts={toasts} />
      {showInvite && <InviteModal onClose={()=>setShowInvite(false)} onInvite={handleInvite} c={c} isDark={isDark} />}

      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <Navbar  sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} pageTitle="Paramètres" />

      <main className="pm-main" style={{ marginLeft:mainML, paddingTop:mainPT }}>
        <div className="pm-layout">

          <div className="pm-nav">
            <div className="pm-nav-card" style={{ background:c.navBg, borderColor:c.cardB, boxShadow:c.shadow }}>
              {SECTIONS.map(s => (
                <button key={s.id} className="pm-nav-item"
                  style={{ background:activeSection===s.id?c.navOn:'transparent', color:activeSection===s.id?'#198754':c.text, fontWeight:activeSection===s.id?700:500, borderBottomColor:c.divider }}
                  onClick={()=>setActiveSection(s.id)}>
                  <span style={{ fontSize:15, opacity:activeSection===s.id?1:0.6 }}>{s.icon}</span>
                  {s.label}
                  {activeSection===s.id && <span style={{ marginLeft:'auto', width:6, height:6, borderRadius:'50%', background:'#198754', flexShrink:0 }} />}
                </button>
              ))}
              <div style={{ padding:'10px 14px', borderTop:`1px solid ${c.divider}`, background:isDark?'rgba(255,255,255,.02)':'rgba(0,0,0,.02)' }}>
                <div style={{ fontSize:10, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'.6px', marginBottom:6 }}>Votre rôle</div>
                <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:700, background:ROLE_COLOR[currentUser.role]?.bg, color:ROLE_COLOR[currentUser.role]?.color }}>
                  {isSuperAdmin && <FaShieldAlt style={{ fontSize:9 }} />}
                  {ROLE_COLOR[currentUser.role]?.label || currentUser.role}
                </span>
              </div>
            </div>
          </div>

          <div className="pm-content">

            {/* PROFIL */}
            {activeSection === 'profil' && (
              <>
                <SectionHeader icon={<FaUser />} title="Profil administrateur" desc="Vos informations personnelles et de contact affichées dans la plateforme." />

                <Block>
                  <div className="pm-avatar-wrap">
                    <AvatarDisplay size={72} radius="16px" fontSize={22} />
                    <input ref={fileRef} type="file" accept="image/*" style={{ display:'none' }}
                      onChange={e => { const f = e.target.files[0]; if (f) saveAvatar(f); e.target.value = ''; }}
                    />
                    <div>
                      {/* FIX : nom affiche depuis le state profil (mis a jour apres sauvegarde) */}
                      <div style={{ fontSize:16, fontWeight:700, color:c.title, marginBottom:4 }}>
                        {[profil.prenom, profil.nom].filter(Boolean).join(' ') || currentUser.nom_complet || 'Administrateur'}
                      </div>
                      <div style={{ fontSize:13, color:c.textDim, marginBottom:10 }}>
                        {profil.poste || 'Administrateur'}
                      </div>
                      <button className="pm-btn-ghost" style={{ borderColor:c.cardB, color:c.text, padding:'7px 14px', fontSize:13 }}
                        onClick={() => fileRef.current?.click()}
                        disabled={avatarUploading}>
                        {avatarUploading
                          ? <><FaSpinner style={{ animation:'pm-spin .8s linear infinite', fontSize:11 }} /> Upload…</>
                          : <><FaCamera style={{ fontSize:11 }} /> Changer la photo</>
                        }
                      </button>
                      {avatarUrl && (
                        <button onClick={removeAvatar}
                          style={{ marginLeft:8, padding:'7px 12px', background:'rgba(220,53,69,.08)', border:'1.5px solid rgba(220,53,69,.2)', borderRadius:11, color:'#dc3545', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
                          Supprimer
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="pm-grid">
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>Civilité</label>
                      <select value={profil.civilite} onChange={e=>setProfil(p=>({...p,civilite:e.target.value}))}
                        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none' }}>
                        <option>M.</option><option>Mme</option><option>Dr</option><option>Prof.</option>
                      </select>
                    </div>
                    <Input label="Poste / Fonction"      value={profil.poste}      half onChange={e=>setProfil(p=>({...p,poste:e.target.value}))} />
                    <Input label="Prénom"                value={profil.prenom}     half onChange={e=>setProfil(p=>({...p,prenom:e.target.value}))} />
                    <Input label="Nom"                   value={profil.nom}        half onChange={e=>setProfil(p=>({...p,nom:e.target.value}))} />
                    <Input label="Email professionnel"   type="email" value={profil.email} half onChange={e=>setProfil(p=>({...p,email:e.target.value}))} />
                    <Input label="Téléphone"             value={profil.telephone}  half onChange={e=>setProfil(p=>({...p,telephone:e.target.value}))} />
                    <div style={{ gridColumn:'span 2', display:'flex', flexDirection:'column', gap:6 }}>
                      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>Bio courte</label>
                      <textarea value={profil.bio} onChange={e=>setProfil(p=>({...p,bio:e.target.value}))} rows={3}
                        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', resize:'vertical', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
                        onFocus={e=>e.target.style.borderColor='#198754'} onBlur={e=>e.target.style.borderColor=c.inputB} />
                    </div>
                  </div>
                </Block>

                <div style={{ display:'flex', justifyContent:'flex-end' }}>
                  <button className="pm-btn-primary" onClick={saveProfil} disabled={loadingProfil}>
                    {loadingProfil ? <><Spin />Enregistrement…</> : <><FaSave />Enregistrer le profil</>}
                  </button>
                </div>
              </>
            )}

            {/* SECURITE */}
            {activeSection === 'securite' && (
              <>
                <SectionHeader icon={<FaShieldAlt />} title="Sécurité du compte" desc="Gérez votre mot de passe et les options de sécurité avancées." />

                <Block title="Changer le mot de passe">
                  <div className="pm-grid-1">
                    {[
                      { key:'current', label:'Mot de passe actuel',       field:'currentPwd' },
                      { key:'new',     label:'Nouveau mot de passe',      field:'newPwd'     },
                      { key:'confirm', label:'Confirmer le mot de passe', field:'confirmPwd' },
                    ].map(f => (
                      <div key={f.key} style={{ display:'flex', flexDirection:'column', gap:6 }}>
                        <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>{f.label}</label>
                        <div className="pm-pwd-wrap">
                          <input
                            type={securite.show[f.key] ? 'text' : 'password'}
                            value={securite[f.field]}
                            onChange={e=>setSecurite(p=>({...p,[f.field]:e.target.value}))}
                            style={{ width:'100%', padding:'10px 44px 10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
                            onFocus={e=>e.target.style.borderColor='#198754'} onBlur={e=>e.target.style.borderColor=c.inputB}
                          />
                          <button className="pm-pwd-eye" style={{ color:c.textDim }}
                            onClick={()=>setSecurite(p=>({...p,show:{...p.show,[f.key]:!p.show[f.key]}}))}>
                            {securite.show[f.key] ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                      </div>
                    ))}
                    <div style={{ display:'flex', alignItems:'center', gap:10, padding:'11px 14px', background:'rgba(25,135,84,0.05)', borderRadius:9, border:'1px solid rgba(25,135,84,0.15)', fontSize:13, color:c.text }}>
                      <FaKey style={{ color:'#198754', flexShrink:0 }} />
                      Minimum 8 caractères, incluant une majuscule et un chiffre.
                    </div>
                  </div>
                  <div style={{ display:'flex', justifyContent:'flex-end', marginTop:18 }}>
                    <button className="pm-btn-primary" onClick={savePassword} disabled={loadingPwd}>
                      {loadingPwd ? <><Spin />Mise à jour…</> : <><FaLock />Mettre à jour le mot de passe</>}
                    </button>
                  </div>
                </Block>

                <Block title="Sécurité avancée">
                  <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                    <Toggle on={securite.twoFA} onToggle={()=>setSecurite(p=>({...p,twoFA:!p.twoFA}))}
                      label="Authentification à deux facteurs (2FA)"
                      desc="Ajoutez une couche de sécurité supplémentaire à votre compte." />
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>Expiration de session (minutes)</label>
                      <select value={securite.sessionTimeout} onChange={e=>setSecurite(p=>({...p,sessionTimeout:e.target.value}))}
                        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', maxWidth:280 }}>
                        {['15','30','60','120','240'].map(v=><option key={v} value={v}>{v} minutes</option>)}
                      </select>
                    </div>
                  </div>
                </Block>

                <Block title="Sessions actives">
                  {[
                    { device:'Chrome — Windows 11', ip:'197.234.12.44', lieu:'Cotonou, Bénin', actif:true  },
                    { device:'Safari — iPhone 15',  ip:'197.234.12.51', lieu:'Cotonou, Bénin', actif:false },
                  ].map((s, i) => (
                    <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'13px 14px', background:c.surface, borderRadius:10, border:`1px solid ${c.cardB}`, marginBottom:i===0?10:0, flexWrap:'wrap', gap:10 }}>
                      <div>
                        <div style={{ fontSize:14, fontWeight:600, color:c.title, marginBottom:3 }}>{s.device}</div>
                        <div style={{ fontSize:12, color:c.textDim }}>{s.ip} · {s.lieu}</div>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        {s.actif && <span style={{ fontSize:12, fontWeight:600, color:'#198754', background:'rgba(25,135,84,0.1)', padding:'3px 10px', borderRadius:20 }}>● Session actuelle</span>}
                        {!s.actif && <button onClick={revokeOtherSessions} style={{ fontSize:13, fontWeight:600, color:'#dc3545', background:'rgba(220,53,69,0.08)', border:'1px solid rgba(220,53,69,0.2)', padding:'5px 12px', borderRadius:8, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>Révoquer</button>}
                      </div>
                    </div>
                  ))}
                </Block>

                <Block title="Zone dangereuse" style={{ border:'1px solid rgba(220,53,69,0.2)', background:isDark?'rgba(220,53,69,0.03)':'rgba(220,53,69,0.01)' }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:14 }}>
                    <div>
                      <div style={{ fontSize:14, fontWeight:600, color:c.title, marginBottom:3 }}>Déconnexion globale</div>
                      <div style={{ fontSize:13, color:c.textDim }}>Terminer toutes les sessions actives sur tous les appareils.</div>
                    </div>
                    <button onClick={revokeOtherSessions}
                      style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 18px', background:'transparent', border:'1.5px solid rgba(220,53,69,0.3)', color:'#dc3545', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", transition:'all .2s' }}
                      onMouseEnter={e=>{e.currentTarget.style.background='#dc3545';e.currentTarget.style.color='#fff';}}
                      onMouseLeave={e=>{e.currentTarget.style.background='transparent';e.currentTarget.style.color='#dc3545';}}>
                      <FaSignOutAlt /> Déconnecter partout
                    </button>
                  </div>
                </Block>
              </>
            )}

            {/* EMAILS SYSTEME */}
            {activeSection === 'emails' && isSuperAdmin && (
              <>
                <SectionHeader icon={<FaEnvelope />} title="Emails système" desc="Configuration de l'expéditeur et du serveur SMTP pour l'envoi des emails automatiques." />

                <Block title="Expéditeur">
                  <div className="pm-grid">
                    <Input label="Nom de l'expéditeur" value={emails.sender_name}  half onChange={e=>setEmails(p=>({...p,sender_name:e.target.value}))} />
                    <Input label="Email expéditeur" type="email" value={emails.sender_email} half onChange={e=>setEmails(p=>({...p,sender_email:e.target.value}))} />
                  </div>
                </Block>

                <Block title="Configuration SMTP">
                  <div className="pm-grid">
                    <Input label="Hôte SMTP"        value={emails.smtp_host} half placeholder="smtp.gmail.com" onChange={e=>setEmails(p=>({...p,smtp_host:e.target.value}))} />
                    <Input label="Port SMTP"        value={emails.smtp_port} half placeholder="587"            onChange={e=>setEmails(p=>({...p,smtp_port:e.target.value}))} />
                    <Input label="Utilisateur SMTP" value={emails.smtp_user} half onChange={e=>setEmails(p=>({...p,smtp_user:e.target.value}))} />
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>Mot de passe SMTP</label>
                      <input type="password" value={emails.smtp_pass} placeholder="••••••••••" onChange={e=>setEmails(p=>({...p,smtp_pass:e.target.value}))}
                        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
                        onFocus={e=>e.target.style.borderColor='#198754'} onBlur={e=>e.target.style.borderColor=c.inputB} />
                    </div>
                  </div>
                  <div style={{ marginTop:16 }}>
                    <button className="pm-btn-ghost" style={{ borderColor:c.cardB, color:c.text, fontSize:13, padding:'8px 16px' }} onClick={testSmtp} disabled={loadingEmail}>
                      {loadingEmail ? <><Spin />Test en cours…</> : 'Tester la connexion SMTP'}
                    </button>
                  </div>
                </Block>

                <Block title="Signature & pied de page">
                  <div className="pm-grid-1">
                    <Toggle on={emails.signature_active} onToggle={()=>setEmails(p=>({...p,signature_active:!p.signature_active}))}
                      label="Ajouter une signature automatique"
                      desc="Incluse dans tous les emails envoyés depuis la plateforme." />
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <label style={{ fontSize:11, fontWeight:700, color:c.textDim, textTransform:'uppercase', letterSpacing:'0.6px' }}>Pied de page email</label>
                      <textarea value={emails.footer} onChange={e=>setEmails(p=>({...p,footer:e.target.value}))} rows={3}
                        style={{ padding:'10px 14px', background:c.input, border:`1.5px solid ${c.inputB}`, borderRadius:10, fontSize:14, color:c.inputT, outline:'none', resize:'vertical', fontFamily:"'Plus Jakarta Sans',sans-serif" }}
                        onFocus={e=>e.target.style.borderColor='#198754'} onBlur={e=>e.target.style.borderColor=c.inputB} />
                    </div>
                  </div>
                </Block>

                <div style={{ display:'flex', justifyContent:'flex-end' }}>
                  <button className="pm-btn-primary" onClick={saveEmails} disabled={loadingEmail}>
                    {loadingEmail ? <><Spin />Enregistrement…</> : <><FaSave />Enregistrer la configuration</>}
                  </button>
                </div>
              </>
            )}

            {/* UTILISATEURS & ROLES */}
            {activeSection === 'utilisateurs' && isSuperAdmin && (
              <>
                <SectionHeader icon={<FaUsers />} title="Utilisateurs & Rôles" desc="Gérez les comptes administrateurs, leurs accès et leur statut de connexion." />

                <Block>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
                    <div style={{ fontSize:14, fontWeight:600, color:c.title }}>{users.length} utilisateur{users.length>1?'s':''}</div>
                    <button className="pm-btn-primary" style={{ padding:'9px 16px', fontSize:13 }} onClick={()=>setShowInvite(true)}>
                      <FaPlus style={{ fontSize:11 }} /> Inviter un administrateur
                    </button>
                  </div>

                  <div style={{ overflowX:'auto' }}>
                    <table className="pm-utbl">
                      <thead>
                        <tr style={{ background:c.surface }}>
                          {['Utilisateur','Rôle','Connecté','Statut','Actions'].map((h, i) => (
                            <th key={i} style={{ color:c.textDim, padding:'10px 14px' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {users.map(u => (
                          <tr key={u.id}>
                            <td style={{ borderBottomColor:c.divider }}>
                              <div style={{ display:'flex', alignItems:'center', gap:11 }}>
                                <div className="pm-uav" style={{ background:u.actif?'#1a2535':c.surface, color:u.actif?'#fff':c.textDim }}>
                                  {u.avatar
                                    ? <img src={resolveAvatar(u.avatar)} alt="" style={{ width:'100%', height:'100%', objectFit:'cover', borderRadius:9 }} />
                                    : (u.nom_complet||'?').split(' ').map(p=>p[0]).join('').toUpperCase().slice(0,2)
                                  }
                                  <span className="pm-online-dot" style={{ background:u.online?'#198754':'#8fa3b5', borderColor:isDark?'#090c16':'#f0f3f8' }} />
                                </div>
                                <div>
                                  <div style={{ fontSize:14, fontWeight:600, color:c.title, display:'flex', alignItems:'center', gap:7 }}>
                                    {u.nom_complet}
                                    {u.id===currentUser.id && <span style={{ fontSize:10, fontWeight:700, color:'#198754', background:'rgba(25,135,84,.1)', padding:'1px 7px', borderRadius:10 }}>Vous</span>}
                                  </div>
                                  <div style={{ fontSize:12, color:c.textDim }}>{u.email}</div>
                                </div>
                              </div>
                            </td>
                            <td style={{ borderBottomColor:c.divider }}>
                              {u.id === currentUser.id ? (
                                <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'4px 10px', borderRadius:8, fontSize:13, fontWeight:600, background:ROLE_COLOR[u.role]?.bg, color:ROLE_COLOR[u.role]?.color }}>
                                  {ROLE_COLOR[u.role]?.label||u.role}
                                </span>
                              ) : (
                                <select value={u.role} onChange={e=>changeUserRole(u.id, e.target.value)}
                                  className="pm-role-select"
                                  style={{ background:ROLE_COLOR[u.role]?.bg, borderColor:'transparent', color:ROLE_COLOR[u.role]?.color }}>
                                  <option value="admin">Admin</option>
                                  <option value="super_admin">Super Admin</option>
                                </select>
                              )}
                            </td>
                            <td style={{ borderBottomColor:c.divider }}>
                              <span style={{ fontSize:12, fontWeight:600, color:u.online?'#198754':c.textDim, background:u.online?'rgba(25,135,84,0.1)':c.surface, padding:'3px 10px', borderRadius:20, display:'inline-flex', alignItems:'center', gap:5 }}>
                                <span style={{ width:6, height:6, borderRadius:'50%', background:u.online?'#198754':'#8fa3b5', display:'inline-block' }} />
                                {u.online ? 'En ligne' : 'Hors ligne'}
                              </span>
                            </td>
                            <td style={{ borderBottomColor:c.divider }}>
                              <button onClick={()=>toggleUserActif(u.id)}
                                style={{ background:'none', border:'none', cursor:u.id===currentUser.id?'not-allowed':'pointer', fontSize:24, color:u.actif?'#198754':c.textDim, transition:'color .2s', opacity:u.id===currentUser.id?0.4:1 }}>
                                {u.actif ? <FaToggleOn /> : <FaToggleOff />}
                              </button>
                            </td>
                            <td style={{ borderBottomColor:c.divider }}>
                              <button onClick={()=>deleteUser(u.id)} disabled={u.id===currentUser.id}
                                style={{ width:32, height:32, borderRadius:8, border:`1.5px solid ${c.cardB}`, background:c.card, color:u.id===currentUser.id?c.textDim:'#dc3545', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, cursor:u.id===currentUser.id?'not-allowed':'pointer', opacity:u.id===currentUser.id?0.35:1, transition:'all .18s' }}
                                onMouseEnter={e=>{ if(u.id!==currentUser.id){e.currentTarget.style.background='rgba(220,53,69,0.08)';e.currentTarget.style.borderColor='#dc3545';}}}
                                onMouseLeave={e=>{ e.currentTarget.style.background=c.card; e.currentTarget.style.borderColor=c.cardB; }}>
                                <FaTrash />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Block>

                <Block title="Permissions par rôle">
                  <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:10 }}>
                    {[
                      { role:'super_admin', perms:['Tout accès','Gestion utilisateurs','Emails système','Paramètres avancés'] },
                      { role:'admin',       perms:['Profil & sécurité','Inscriptions','Devis','Formations','Contacts','Rapports'] },
                    ].map(r => (
                      <div key={r.role} style={{ padding:'14px 16px', background:c.surface, borderRadius:11, border:`1px solid ${c.cardB}` }}>
                        <div style={{ fontSize:13, fontWeight:700, color:ROLE_COLOR[r.role]?.color, marginBottom:10, background:ROLE_COLOR[r.role]?.bg, display:'inline-block', padding:'2px 10px', borderRadius:20 }}>
                          {ROLE_COLOR[r.role]?.label}
                        </div>
                        {r.perms.map(p => (
                          <div key={p} style={{ display:'flex', alignItems:'center', gap:7, fontSize:13, color:c.text, marginBottom:5 }}>
                            <FaCheck style={{ fontSize:10, color:'#198754', flexShrink:0 }} /> {p}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </Block>
              </>
            )}

          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;